import ReactDOM from "react-dom/client";
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
import Home from './pages/home';
import Bottom from './bottom';
import Project from './pages/project';
import Blog from './pages/blog';
import ReactPatterns from "./pages/blog/react-patterns";
import ScssArchitecture from "./pages/blog/scss-architecture";
import SassTips from "./pages/blog/sass-tips";
import BemBestPractices from "./pages/blog/bem-best-practices";
import BemitExplained from "./pages/blog/bemit-guide";
import FrontendPerformance from "./pages/blog/frontend-performance";
import SmoothParticles from "./pages/SmoothParticles";
import NotFound from "./pages/404";
import Gitcheck from "./pages/blog/gitcheck";

function App() {
  // Tema state
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  // Tema değiştirme fonksiyonu
  const toggleTheme = () => {
    setTheme((currentTheme) => {
      const newTheme = currentTheme === 'light' ? 'dark' : 'light';

      // Ana içerik arka planını güncelle
      const mainImageContent = document.querySelector('.main-image-content');
      if (mainImageContent) {
        mainImageContent.classList.remove(`${currentTheme}-background`);
        mainImageContent.classList.add(`${newTheme}-background`);
      }

      // LocalStorage’a kaydet
      localStorage.setItem('theme', newTheme);

      // HTML element attribute ile CSS’te kullanabilirsin
      document.documentElement.setAttribute('data-theme', newTheme);

      return newTheme;
    });
  };

  // Sayfa açıldığında localStorage’daki temayı uygula
  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      setTheme(storedTheme);
      document.documentElement.setAttribute('data-theme', storedTheme);
    }
  }, []);

  return (
    <div className={`app ${theme}`}>
      {/* Particles veya animasyonlar */}
      <SmoothParticles />

      <BrowserRouter> 
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="project" element={<Project />} />
          <Route path="blog" element={<Blog />} />    
          <Route path="blog/react-patterns" element={<ReactPatterns />} />
          <Route path="blog/scss-architecture" element={<ScssArchitecture />} />
          <Route path="blog/sass-tips" element={<SassTips />} />
          <Route path="blog/bem-best-practices" element={<BemBestPractices />} />
          <Route path="blog/bemit-guide" element={<BemitExplained />} />
          <Route path="blog/frontend-performance" element={<FrontendPerformance />} />
          <Route path="blog/gitcheck" element={<Gitcheck />} />
          {/* 404 Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* Bottom menü */}
        <Bottom theme={theme} toggleTheme={toggleTheme} />
      </BrowserRouter> 
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

export default App;